import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { SimplePaymentMethod } from '@services/payment/types/simple-payment-method';

export class GetPaymentMethods implements LoadingAction {
  readonly type = actions.GET_PAYMENT_METHODS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public ownerId: string) {}
}

export class GetPaymentMethodsSuccess implements LoadingAction {
  readonly type = actions.GET_PAYMENT_METHODS_SUCCESS;
  readonly isLoading = false;

  constructor(public ownerId: string, public list: SimplePaymentMethod[]) {}
}

export class GetPaymentMethodsError implements ErrorAction {
  readonly type = actions.GET_PAYMENT_METHODS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class AddPaymentMethod implements LoadingAction {
  readonly type = actions.ADD_PAYMENT_METHOD;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public ownerId: string, public paymentMethodId: string) {}
}

export class AddPaymentMethodSuccess implements LoadingAction {
  readonly type = actions.ADD_PAYMENT_METHOD_SUCCESS;
  readonly isLoading = false;

  constructor(public ownerId: string, public paymentMethodId: string) {}
}

export class AddPaymentMethodError implements ErrorAction {
  readonly type = actions.ADD_PAYMENT_METHOD_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RemovePaymentMethod implements LoadingAction {
  readonly type = actions.REMOVE_PAYMENT_METHOD;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public ownerId: string, public paymentMethodId: string) {}
}

export class RemovePaymentMethodSuccess implements LoadingAction {
  readonly type = actions.REMOVE_PAYMENT_METHOD_SUCCESS;
  readonly isLoading = false;

  constructor(public ownerId: string, public paymentMethodId: string) {}
}

export class RemovePaymentMethodError implements ErrorAction {
  readonly type = actions.REMOVE_PAYMENT_METHOD_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type PaymentActions =
  | GetPaymentMethods
  | GetPaymentMethodsSuccess
  | GetPaymentMethodsError
  | AddPaymentMethod
  | AddPaymentMethodSuccess
  | AddPaymentMethodError
  | RemovePaymentMethod
  | RemovePaymentMethodSuccess
  | RemovePaymentMethodError;
